import { computed, type WritableComputedRef } from 'vue'

export function useCriterionField<Row extends object, Key extends keyof Row>(
  props: { row: Row },
  emits: (e: 'update:row', row: Row) => void,
  key: Key,
): WritableComputedRef<Row[Key]> {
  return computed({
    get: () => props.row[key],
    set: (value) => emits('update:row', { ...props.row, [key]: value }),
  })
}
